/**
 *  @class
 *  @function StickyScroller
 */
if (!customElements.get('sticky-scroller')) {
  class StickyScroller extends HTMLElement {

    constructor() {
      super();
      this.newScrollPosition = 0;
      this.oldScrollPosition = 0;
      this.ticking = false;
    }

    connectedCallback() {
      this.parent = this.closest('.sticky-scroller--parent');
      if (!this.parent) return;

      this.element = this.querySelector('.sticky-scroller--element');
      this.siblings = this.parent.querySelectorAll('.sticky-scroller--compare');
      this.collapsibles = this.parent.querySelectorAll('.accordion');
      this.headerHeight = this.getHeaderHeight();

      this._onWindowResize = () => {
        this.headerHeight = this.getHeaderHeight();
        this.recalculate();
      };
      this._onScroll = this.onScroll.bind(this);
      this._onAnimationEnd = () => this.recalculate();
      this._onVariantChange = () => this.recalculate();

      window.addEventListener('resize', this._onWindowResize);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      document.addEventListener('product:variant-change', this._onVariantChange);

      this.collapsibles.forEach((collapsible) => {
        collapsible.addEventListener('animationend', this._onAnimationEnd);
      });

      window.dispatchEvent(new Event('resize'));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onWindowResize);
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('product:variant-change', this._onVariantChange);

      this.collapsibles?.forEach((collapsible) => {
        collapsible.removeEventListener('animationend', this._onAnimationEnd);
      });
    }

    getHeaderHeight() {
      return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    }

    getSiblingsHeight() {
      let height = 0;
      this.siblings.forEach((sibling) => {
        height += sibling.offsetHeight;
      });
      return height;
    }

    recalculate() {
      this.disable(false);

      const siblingsHeight = this.getSiblingsHeight();
      const elementHeight = this.element.offsetHeight;

      if (siblingsHeight) {
        if (siblingsHeight <= elementHeight) {
          this.disable(true);
        } else {
          this.activate();
        }
      }
    }

    onScroll() {
      this.newScrollPosition = window.scrollY;

      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.translate();
          this.ticking = false;
          this.oldScrollPosition = this.newScrollPosition;
        });

        this.ticking = true;
      }
    }

    activate() {
      this.element.style.overflowY = 'hidden';
      this.element.classList.remove('sticky-scroller--disabled');

      this.ticking = false;
      window.dispatchEvent(new Event('scroll'));
    }

    disable(scroll) {
      if (scroll) {
        this.element.style.overflowY = 'auto';
      }
      this.element.classList.add('sticky-scroller--disabled');
    }

    translate() {
      const parentRect = this.parentElement.getBoundingClientRect();
      const distance = this.newScrollPosition - this.oldScrollPosition;

      if (parentRect.top > this.headerHeight && distance > 0) {
        return;
      }
      if (parentRect.bottom < window.innerHeight && distance < 0) {
        return;
      }
      this.element.scrollTop += distance;
    }
  }
  customElements.define('sticky-scroller', StickyScroller);
}
